'use client';

import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';
import { NotFoundErrorWidget } from '@/modules/Maintenance/ui/NotFoundErrorWidget';
import { UnknowErrorWidget } from '@/modules/Maintenance/ui/UnknowErrorWidget';

const ErrorPage = ({ error }: ErrorProps) => {
  const statusCode = error.statusCode ?? 500;

  useEffect(() => {
    captureException(error);
  }, [error]);

  return statusCode === 404 ? <NotFoundErrorWidget /> : <UnknowErrorWidget />;
};

export default ErrorPage;

type ErrorProps = {
  error: Error & { digest?: string; statusCode?: number };
};
